import { useEffect, useState, lazy } from "react"
import styles from "../../assets/styles/appointments.module.css"
import { FormGroup, InputAdornment, MenuItem, Select, TextField } from "@mui/material"
import { yearsData } from "../../utils/functions/Data"
import { SearchIcon } from "../../utils/functions/Icons"
import { RootState } from "../../utils/store"
import { useSelector } from "react-redux"
import { getAssessmentHraApi, sendReminderApi } from "../../utils/api/services"
import { toast } from "react-toastify"

const CustomContainer = lazy(() => import("../../components/common/CustomContainer"))
const HraTable = lazy(() => import("../../components/hra/HraTable"))
const HraCharts = lazy(() => import("../../components/hra/HraCharts"))
const ConfirmModal = lazy(() => import("../../components/common/ConfirmModal"))
const Loader = lazy(() => import("../../components/common/Loader"))


const HraPage = () => {
    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
    const [searchValue, setSearchValue] = useState('')
    const [openConfirmModal, setOpenConfirmModal] = useState(false)
    const [email, setEmail] = useState<string>("")
    const [btnLoading, setBtnLoading] = useState(false)
    const [loading, setLoading] = useState(false);
    const [hraData, setHraData] = useState<HRAData | null>(null);
    const { LoginData } = useSelector((state: RootState) => state.auth)

    const handleOpenConfirmModal = (email: string) => {
        setOpenConfirmModal(true)
        setEmail(email)
    }
    const CloseConfirmModal = () => {
        setOpenConfirmModal(false)
        setEmail("")
    }
    const fetchHraData = async (data: { companyId: number, search: string, year: number }) => {
        try {
            setLoading(true)
            const result = await getAssessmentHraApi(data);
            if (result?.success) {
                setLoading(false)
                setHraData(result?.data)
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (LoginData) {
            if (searchValue) {
                const cleanFunction = setTimeout(() => {
                    fetchHraData({ companyId: LoginData?.companyId, search: searchValue ? searchValue : '', year: selectedYear });
                }, 1000);
                return () => clearTimeout(cleanFunction);
            } else {
                fetchHraData({ companyId: LoginData?.companyId, search: searchValue ? searchValue : '', year: selectedYear });
            }
        }
    }, [searchValue, selectedYear]);

    const confirmSubmit = async () => {
        try {
            setBtnLoading(true)
            const result = await sendReminderApi(email);
            if (result?.success) {
                setBtnLoading(false)
                toast.success(result?.message)
                if (LoginData) {
                    fetchHraData({ companyId: LoginData?.companyId, search: searchValue ? searchValue : '', year: selectedYear });
                }
                CloseConfirmModal();
            }
        } catch (error: any) {
            setBtnLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }
    if (loading) {
        return <Loader />
    }
    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>HRA</h2>
                </div>
                <div className={styles.filter}>
                    <h3>HRA summary by year</h3>
                    <Select
                        className="custumTextField profileInput forYearFilter"
                        name="year"
                        value={selectedYear || ''}
                        onChange={(e) => setSelectedYear(Number(e.target.value))}
                    >
                        {yearsData.map((year) => (
                            <MenuItem key={year} value={year}>
                                {year}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <HraCharts empMonthWise={hraData?.empMonthWise} hraDetaails={hraData?.hraDetaails} />
                <div className={`${styles.appointmentsMain} mt-8`}>
                    <div>
                        <div className={'mb-6 flex justify-between items-center flex-col md:flex-row w-full max-w-full gap-y-4 md:gap-y-0'}>
                            <FormGroup className="customFormGroup md:w-1/2 w-full">
                                <TextField
                                    className={`custumTextField ${styles.InputStyle}`}
                                    id="searchValue"
                                    name="searchValue"
                                    onChange={(e) => setSearchValue(e.target.value)}
                                    value={searchValue}
                                    placeholder='search'
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </FormGroup>
                        </div>
                        <HraTable hraData={hraData} handleOpenConfirmModal={handleOpenConfirmModal} />
                    </div>
                </div>
            </div>
            <ConfirmModal
                openConfirmModal={openConfirmModal}
                CloseConfirmModal={CloseConfirmModal}
                confirmSubmit={confirmSubmit}
                btnLoading={btnLoading}
                title={`Are you sure you want to send reminder?`}
            />
        </CustomContainer>
    )
}

export default HraPage